import classnames from "classnames";
import { noop } from "neetocist";
import { joinHyphenCase } from "neetocommons/utils/general";
import { Typography } from "neetoui";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import "./menubar.scss";

const Block = ({
  url,
  icon,
  label,
  count,
  active = false,
  onEdit,
  onClick = noop,
  className,
  ...otherProps
}) => {
  const handleEdit = e => {
    e.stopPropagation();
    onEdit && onEdit();
  };

  const Parent = url ? Link : props => <button {...props} />;

  return (
    <Parent
      data-testid={otherProps["data-testid"] || "menubar-block"}
      to={url}
      className={classnames("neeto-molecules-menubar__block", {
        "neeto-molecules-menubar__block--editable": !!onEdit,
        "neeto-molecules-menubar__block--active": active,
        [className]: className,
      })}
      {...{ onClick, ...otherProps }}
    >
      <div
        className="neeto-molecules-menubar__block-label"
        data-testid={joinHyphenCase("menubar-block-label", label)}
      >
        {icon && <i className="neeto-molecules-menubar__block-icon">{icon}</i>}
        <Typography component="span" style="h5" title={label} weight="medium">
          {label}
        </Typography>
      </div>
      {Number.isInteger(count) && (
        <div onClick={handleEdit}>
          <Typography component="span" style="h5" weight="medium">
            {count}
          </Typography>
        </div>
      )}
    </Parent>
  );
};

Block.propTypes = {
  /**
   * To provide the url of the Block.
   */
  url: PropTypes.string,
  /**
   * To provide the icon of the Block.
   */
  icon: PropTypes.node,
  /**
   * To provide the label of the Block.
   */
  label: PropTypes.string,
  /**
   * To specify the count of items in the Block.
   */
  count: PropTypes.number,
  /**
   * To specify whether the Block is active.
   */
  active: PropTypes.bool,
  /**
   * The handler function that is called when the number is clicked.
   */
  onEdit: PropTypes.func,
  /**
   * To provide a callback function on click of the Block.
   */
  onClick: PropTypes.func,
  /**
   * To specify external classnames as overrides to the Block.
   */
  className: PropTypes.string,
};

export default Block;
